module.exports = __webpack_public_path__ + "img/logo_langt.279c28ce.svg";